/**
 * Discriminador do relatório "Pontos por Produto da Venda" (Relatórios -> Pontos -> Por Venda (API)).
 *
 * `sale_partner_product.as_product_id` aponta pra `fuel` OU pra `sale_product` — a mesma coluna,
 * duas tabelas. O backend devolve este tipo em cada linha e aceita ele no filtro.
 * Espelha `ProductPointsType` de pontuax-backend/src/models/productPointsType.ts.
 */
export enum ProductPointsType {
  fuel = 'fuel',
  product = 'product',
};

export namespace ProductPointsType {
  export const translateType = (type: ProductPointsType): string => {
    switch (type) {
      case ProductPointsType.fuel:
        return "Combustível";
      case ProductPointsType.product:
        return "Produto";
      default: return "";
    };
  };

  export const productPointsTypeChoices = Object.values(ProductPointsType).filter(x => typeof x === "string")
    .map(type => {
      return ({
        id: type,
        name: ProductPointsType.translateType(type)
      })
    });
};
